import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PetPairingComponent } from './pet-pairing/pet-pairing.component';
import { ConsoleIconComponent } from './header/icons/console-icon/console-icon.component';
import { HeaderComponent } from './header/header.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { LoaderComponent } from './loader/loader.component';
import { MenuComponent } from './menu/menu.component';
import { HcrConsoleModule } from '../card-reader/hcr-console/hcr-console.module';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';
import { SecurityModule } from '../security/security.module';
import { SharedModule } from '../shared/shared.module';
import { PatientInfoWindowSharedModule } from '../shared/components/patients/patient-info-window-shared.module';
import { RouterModule } from '@angular/router';
import { ReportHelperModule } from '../system/report/report-helper.module';
import { PatientQueryDialogModule } from '../patients/patient-query-dialog/patient-query-dialog.module';
import { DebugToolComponent } from './debug-tool/debug-tool.component';
import { ChatComponent } from './chat/chat.component';
import { MwsSettingComponent } from './header/icons/mws-setting/mws-setting.component';
import { NotifyLogComponent } from './header/icons/notify-log/notify-log.component';
import { NotifyComponent } from './notify/notify.component';
import { MineComponent } from './extra/mine/mine.component';
import { CardComponent } from './extra/poker/card/card.component';
import { PokerDeskComponent } from './extra/poker/poker-desk/poker-desk.component';
import { HandCardsComponent } from './extra/poker/hand-cards/hand-cards.component';
import { GomokuComponent } from './extra/gomoku/gomoku.component';
import { StockRoomListModule } from '../stocks/stock-room/stock-room-list.module';
import { StockRoomBatchListModule } from '../stocks/stock-room-batch/stock-room-batch-list.module';
import { ProductBatchInactiveListModule } from '../stocks/product-batch/product-batch-inactive-list.module';
import { ChiMedExpireToolComponent } from './debug-tool/chi-med-expire-tool/chi-med-expire-tool.component';
import { SnackComponent } from './extra/snack/snack.component';
import { SpsStatusComponent } from './header/icons/sps-status/sps-status.component';
import { PrinterComponent } from './header/icons/printer/printer.component';
import { SystemSettingExportImportComponent } from './debug-tool/system-setting-export-import/system-setting-export-import.component';
import { BrandLoadingMaskComponent } from './brand-loading-mask/brand-loading-mask.component';

@NgModule({
  declarations: [
    PetPairingComponent,
    ConsoleIconComponent, 
    HeaderComponent, 
    MainLayoutComponent, 
    BrandLoadingMaskComponent,
    LoaderComponent, 
    MenuComponent, 
    DebugToolComponent, 
    ChatComponent, 
    PrinterComponent, 
    MwsSettingComponent,
    NotifyLogComponent, 
    NotifyComponent, 
    MineComponent, 
    CardComponent, 
    PokerDeskComponent, 
    HandCardsComponent, 
    GomokuComponent, 
    SnackComponent, 
    ChiMedExpireToolComponent,
    SpsStatusComponent, 
    SystemSettingExportImportComponent
  ],
  imports: [
    RouterModule,
    SecurityModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    PatientInfoWindowSharedModule,
    HcrConsoleModule,
    ReportHelperModule,
    PatientQueryDialogModule,
    StockRoomListModule,
    StockRoomBatchListModule,
    ProductBatchInactiveListModule,
    CommonModule,
  ]
})
export class LayoutModule { }
